class Taxes {
  constructor(taxesObject) {
    this.taxesObject = taxesObject;
  }

  getTaxesList() {
    return Object.keys(this.taxesObject)
      .filter((key) => {
        return (
          key !== "post_total_tax" &&
          this.taxesObject[key] &&
          this.taxesObject[key].amount > 0
        );
      })
      .map(
        (key) =>
          new Tax(key, {
            value: this.taxesObject[key],
            displayName: this.taxesObject[key + "_display_name"],
          })
      )
      .sort((aTax1, aTax2) => aTax1.getPosition() - aTax2.getPosition());
  }
}

class Tax {
  static TaxMeta = {
    county_tax: {displayName: "County Tax", position: 1},
    city_tax: {displayName: "City Tax", position: 2},
    state_tax: {displayName: "State Tax", position: 3},
    excise_tax: {displayName: "Excise Tax", position: 4},
    fed_tax: {displayName: "Fed Tax", position: 5},
    al_excise_tax: {displayName: "AL Excise Tax", position: 6},

    pre_county_tax: {displayName: "Pre County tax", position: 7},
    pre_city_tax: {displayName: "Pre City Tax", position: 8},
    pre_state_tax: {displayName: "Pre State Tax", position: 9},
    pre_fed_tax: {displayName: "Pre Fed Tax", position: 10},
    nal_pre_excise_tax: {displayName: "NAL Pre Excise Tax", position: 11},

    al_post_excise_tax: {displayName: "AL Post Excise Tax", position: 12},

    post_total_tax: {displayName: "Post Total Tax", position: 13},
    pre_total_tax: {displayName: "Pre Total Tax", position: 14},
  };

  constructor(key, taxObj) {
    this.meta = Tax.TaxMeta[key] || {displayName: "Tax", position: 0};
    this.taxObj = taxObj;
  }

  getValue() {
    return this.taxObj.value;
  }
  getDisplayName() {
    return this.taxObj.displayName || this.meta.displayName;
  }
  getPosition() {
    return this.meta.position;
  }
}

export default Taxes;
